<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    class="block-plan-icon"
  >
    <rect
      transform="rotate(-8 8.5 12.8)"
      rx="0.75"
      height="13.2"
      width="13.2"
      y="5.9"
      x="2.1"
    />
    <polyline points="1.51 3.75 13.64 2.01" />
    <polyline points="17.31 5.3 19.04 17.43" />
    <g class="c">
      <polyline points="2.37 4.81 1.03 3.81 2.03 2.46" />
      <polyline points="12.18 1.03 13.52 2.03 12.52 3.37" />
      <polyline points="16.25 6.16 17.25 4.82 18.59 5.83" />
      <polyline points="20.03 15.97 19.03 17.32 17.69 16.31" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BlockPlanIcon',
};
</script>

<style scoped lang="scss">
.block-plan-icon > *{
  fill: none;
  stroke: var(--feature-color, main.$npGray);
  stroke-miterlimit: 10;
  stroke-width: 1.25px;
}
.block-plan-icon.disabled > * {
  stroke: darkgrey;
}
.block-plan-icon.selected > * {
  stroke: #fff;
}
.c > *{
  fill-rule: evenodd;
  stroke-linecap: square;
}
</style>
